{
  "el": {
    "timestamp": {
      "labels": {
        "accepted": "Έγινε αποδεκτό {date}",
        "ago": "πριν",
        "daysAgo": "{days} ημέρα |{days} ημέρες",
        "daysRemaining": "απομένουν {days} ημέρες",
        "deadlineDaysLeft": "Απομένουν {days} ημέρες",
        "deadlineOverdue": "Εκπρόθεσμο",
        "due": "Προθεσμία {date}",
        "dueToday": "Λήγει σήμερα",
        "dueWas": "Προθεσμία ήταν {date}",
        "expired": "Έληξε {date}",
        "hoursAgo": "{hours} ώρα | {hours} ώρες",
        "in": "Σε {time}",
        "justNow": "Μόλις τώρα",
        "minutesAgo": "{minutes} λεπτό | {minutes} λεπτά",
        "monthsAgo": "{months} μήνας | {months} μήνες",
        "noDeadline": "Δεν έχει οριστεί προθεσμία",
        "overdue": "Εκπρόθεσμο κατά {days} ημέρες",
        "sentOn": "Στάλθηκε στις {date}",
        "sentOnAt": "Στάλθηκε στις {date} και ώρα {time}",
        "starts": "Ξεκινά {date}",
        "today": "Σήμερα",
        "tomorrow": "Αύριο",
        "uploaded": "Ανέβηκε {date}",
        "weeksAgo": "{weeks} εβδομάδα | {weeks} εβδομάδες",
        "yearsAgo": "{years} χρόνος | {years} χρόνια",
        "yesterday": "Χθες"
      }
    }
  }
}
